// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-table-component .delete-btn[data-v-40b17ac0],.event-table-component .edit-btn[data-v-40b17ac0],.event-table-component .status-btn[data-v-40b17ac0]{width:64px}.event-table-component .edit-btn[data-v-40b17ac0]{margin-right:12px}.event-table-component .preview img[data-v-40b17ac0]{width:106px;border:1px solid #bbb;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
